import * as Yup from "yup";

export const initialValues = {
  redeemDate: null,
  startTime: "00:00:00",
  endTime: "00:00:00",
  collectTimeId: null,
  description: null,
};

const RedeemTimeSchema = Yup.object().shape({
  redeemDate: Yup.string().required("Please select."),
  collectTimeId: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
});

export default RedeemTimeSchema;
